<template>
  <div>
    <Form ref="searchForm" inline :label-width="70">
      <Form-item label="题目类型">
        <EnumSelect
          type="QuestionType"
          selector="select"
          v-model="searchCondition.ques_type"
          style="width:200px"
        ></EnumSelect>
      </Form-item>
      <Form-item label="题干名称">
        <Input
          style="width:200px"
          placeholder="请输入题干关键字"
          v-model="searchCondition.ques_stem"
          clearable
          @keydown.native.enter="search(1)"
        />
      </Form-item>
      <Form-item label="考点">
        <Cascader :data="points" v-model="selectPoints" clearable :change-on-select="true"></Cascader>
      </Form-item>
      <Form-item class="search-form-btns">
        <div class="btn-wrap form-item-search">
          <Button icon="ios-search" @click="search(1)">搜索</Button>
          <Button icon="md-undo" @click="search(0)">重置</Button>
        </div>
      </Form-item>
    </Form>
    <div>
      <Button type="primary" :to="{name:'QuestionBankTopicEdit',query:{bank:$route.query.id}}">新增题目</Button>
      <Button
        type="default"
        :to="{name:'QuestionBankTopicImport',query:{bank:$route.query.id}}"
        style="margin-left:20px;"
      >导入试题</Button>
      <Checkbox v-model="onlyShowMine" @on-change="onMineChange" style="margin-left:20px;">只看我创建的</Checkbox>
    </div>
    <div class="content">
      <Grid
        ref="grid"
        :autoLoadData="false"
        :columns="columns"
        data-url="/api/question"
        :search="searchCondition"
        :rowsFormatter="rowsFormatter"
        @onSelectionChange="onSelectionChange"
        selectType="multi"
        keyField="id"
        method="get"
        class="elastic-table"
      >
        <template slot-scope="{ row }" slot="c1">
          <Tooltip
            class="flex-tip"
            placement="right"
            @on-popper-show="showTip(row.id)"
            theme="light"
          >
            <div class="rich-text-small" v-html="row.ques_stem"></div>
            <div slot="content">
              <div class="stem rich-text" v-html="tip.stem"></div>
              <div v-if="tip.type!=4">
                <div class="option" v-for="(option,index) in tip.options" :key="index">
                  <div class="header">
                    <span>选项{{chars[index]}}</span>
                    <span class="line">|</span>
                    <Radio
                      v-model="option.is_right"
                      v-if="tip.type==1||tip.type==3"
                      @on-change="onOptionChange(index)"
                    >是否为正确答案</Radio>
                    <Checkbox
                      v-model="option.is_right"
                      v-else-if="tip.type==2"
                      @on-change="onOptionChange(index)"
                    >是否为正确答案</Checkbox>
                  </div>
                  <div>
                    <div v-html="option.content"></div>
                    <div style="clear:both;"></div>
                  </div>
                </div>
              </div>
              <div v-else class="line-topic">
                <div>
                  <div class="option" v-for="(stem,index) in tip.stems" :key="index">
                    <div class="stem">
                      <div>{{index+1}}）</div>
                      <div v-html="stem.content"></div>
                    </div>
                    <div class="answer">
                      <span>答案</span>
                      <RadioGroup v-model="stem.is_right" @on-change="onOptionChange">
                        <Radio
                          :label="index"
                          v-for="(option,index) in tip.options"
                          :key="index"
                        >{{chars[index]}}</Radio>
                      </RadioGroup>
                    </div>
                  </div>
                </div>
                <div>
                  <div class="option" v-for="(option,index) in tip.options" :key="index">
                    <div style="margin-bottom:15px;">选项{{chars[index]}}</div>
                    <div v-html="option.content"></div>
                  </div>
                </div>
              </div>
            </div>
          </Tooltip>
        </template>
        <template slot-scope="{ row }" slot="action">
          <Button
            type="text"
            size="small"
            :to="{name:'QuestionBankTopicEdit',query:{bank:$route.query.id,id:row.id}}"
          >编辑-</Button>
          <Button type="text" size="small" @click="deleteTopic(row.id)">删除</Button>
        </template>
        <template slot="footer-left">
          <Button
            class="btn-margin-right"
            type="text"
            :disabled="selectList.length == 0"
            @click="batchDelete"
          >删除</Button>
          <Button
            class="btn-margin-right"
            type="text"
            :disabled="selectList.length == 0||selectPoints.length==0"
            @click="transfer"
          >转移</Button>
        </template>
      </Grid>
    </div>
    <Modal v-model="showSelectPointModal" title="选择目标考点">
      <Cascader :data="points" v-model="transferPoints" clearable></Cascader>
      <template v-slot:footer>
        <div>
          <Button type="default" @click="showSelectPointModal=false">取消</Button>
          <Button type="primary" @click="confirmTransfer">确定</Button>
        </div>
      </template>
    </Modal>
    <Spin size="large" fix v-if="spinShow"></Spin>
  </div>
</template>
<script>
import { QuestionType } from "../../utils/enums.js";

export default {
  name: "QuestionBankTopic",
  mounted(){
    this.mathJax()
  },
  data() {
    return {
      onlyShowMine: false,
      spinShow:true,
      searchCondition: {
        ques_type: "",
        ques_stem: "",
        bank: "",
        point_id: ""
      },
      columns: [
        {
          title: "题干名称",
          key: "ques_stem",
          slot: "c1"
        },
        {
          title: "题目类型",
          key: "ques_type_name",
          width: 150
        },
        {
          title: "所属考点",
          key: "point",
          width: 200
        },
        {
          title: "创建人",
          key: "creator",
          width: 150
        },
        {
          title: "更新时间",
          key: "updated_at_time",
          width: 150
        },
        {
          title: "操作",
          slot: "action",
          width: 150,
          align: "center"
        }
      ],
      selectList: [],
      chars: { 0: "A", 1: "B", 2: "C", 3: "D", 4: "E", 5: "F" },
      tip: {
        id: "",
        points: [],
        type: "",
        stem: "",
        analysis: "",
        options: [],
        stems: []
      },
      points: [],
      selectPoints: [],
      showSelectPointModal: false,
      transferPoints: []
    };
  },
  async activated() {
    await this.getPoint();
    this.searchCondition.bank = this.$route.query.id;
    if (this.$route.query.reload) {
      this.search(0);
    } else {
      this.$refs.grid.refresh();
    }
  },
  methods: {
    mathJax() {
      let _this = this;
      if (this.MathJax.isMathjaxConfig) { // 判断是否初始配置，若无则配置。
          this.MathJax.initMathjaxConfig()
      }
      setTimeout(function(){
        _this.MathJax.MathQueue()// 传入组件id，让组件被MathJax渲染
        _this.spinShow = false;
      },2000)
    },
    async getPoint() {
      let list = await this.$http.get("/api/exam/point");
      let points = [];
      let pointFormat = function(point) {
        let newPoint = { value: point.id, label: point.name, children: [] };
        if (point.child) {
          point.child.forEach(p => {
            newPoint.children.push(pointFormat(p));
          });
        }
        return newPoint;
      };
      list.forEach(p => {
        if (!p.child || p.child.length == 0) {
          return;
        }
        let point = pointFormat(p);
        points.push(point);
      });
      this.points = points;
    },
    search(flag) {
      if (flag == 0) {
        this.searchCondition.ques_stem = "";
        this.searchCondition.ques_type = "";
        this.searchCondition.uid = "";
        this.searchCondition.point_id = "";
        this.selectPoints = [];
      } else {
        this.searchCondition.uid = this.onlyShowMine
          ? this.$store.state.user.id
          : "";
        if (this.selectPoints.length > 0) {
          this.searchCondition.point_id = this.selectPoints[
            this.selectPoints.length - 1
          ];
        } else {
          this.searchCondition.point_id = "";
        }
      }
      this.$refs.grid.searchRefresh();
    },
    onMineChange() {
      this.search(1);
    },
    rowsFormatter(rows) {
      rows.forEach(row => {
        if (row.updated_at) {
          row.updated_at_time = new Date(
            parseInt(row.updated_at) * 1000
          ).format("yyyy-MM-dd hh:mm:ss");
        }
        row.ques_type_name = QuestionType.getValue(row.ques_type);
      });
    },
    onSelectionChange(list) {
      this.selectList = list;
    },
    async deleteTopic(id) {
      await this.$promiseConfirm("确定要删除该试题吗？");
      await this.$http.delete("/api/question/" + id);
      this.$Message.deleteSuccess();
      this.$refs.grid.refresh();
    },
    async batchDelete() {
      let ids = [];
      this.selectList.forEach(t => {
        ids.push(t.id);
      });
      await this.$promiseConfirm("确定要删除选择的试题吗？");
      await this.$http.delete("/api/question/" + ids.join(","));
      this.$Message.deleteSuccess();
      this.$refs.grid.refresh();
      this.selectList = [];
    },
    async showTip(id) {
      this.tip.id = id;
      this.tip.stem = "加载中，请稍后...";
      this.tip.options = [];
      this.tip.stems = [];
      let data = await this.$http.get("/api/question/" + id);
      this.tip.type = data.ques_type;
      this.tip.stem = data.ques_stem;
      this.tip.analysis = data.ques_analysis;
      this.tip.options = [];
      if (data.ques_type != 4) {
        let options = [];
        data.ques_option.forEach(o => {
          options.push({
            content: o.content,
            is_right: o.is_right == 1
          });
        });
        this.tip.options = options;
      } else {
        let stems = [];
        data.ques_option.left.forEach(o => {
          stems.push({
            content: o.content,
            is_right: o.is_right - 1
          });
        });
        this.tip.stems = stems;

        let options = [];
        data.ques_option.right.forEach(o => {
          options.push({
            content: o.content
          });
        });
        this.tip.options = options;
      }
      let _this = this;
      setTimeout(function(){
        _this.MathJax.MathQueue();
      },300)
    },
    async onOptionChange(index) {
      if (this.tip.type == 1 || this.tip.type == 3) {
        this.tip.options.forEach((o, i) => {
          o.is_right = index == i;
        });
      }
      let poitIds = [];
      this.tip.points.forEach(p => {
        poitIds.push(p.id);
      });
      let data = {
        point: poitIds.join(","),
        ques_type: this.tip.type,
        ques_stem: this.tip.stem,
        ques_analysis: this.tip.analysis,
        bank_id: this.$route.query.id
      };
      if (data.ques_type != 4) {
        let options = [];
        this.tip.options.forEach(o => {
          options.push({ content: o.content, is_right: o.is_right ? 1 : 0 });
        });
        data.ques_option = JSON.stringify(options);
      } else {
        let options = [];
        this.tip.stems.forEach(o => {
          options.push({ content: o.content, is_right: o.is_right + 1 });
        });
        data.ques_option = JSON.stringify(options);
        let results = [];
        this.tip.options.forEach(o => {
          results.push({ content: o.content });
        });
        data.connection_result = JSON.stringify(results);
      }
      await this.$http.put("/api/question/" + this.tip.id, data);
      this.$Message.saveSuccess();
    },
    async transfer() {
      this.showSelectPointModal = true;
    },
    async confirmTransfer() {
      if (this.transferPoints.length == 0) {
        await this.$Message.info("请选择目标考点");
        return;
      }
      let ids = [];
      this.selectList.forEach(q => {
        ids.push(q.id);
      });
      await this.$http.put(
        "/api/exam/point/move/" +
          this.selectPoints[this.selectPoints.length - 1] +
          "/" +
          this.transferPoints[this.transferPoints.length - 1],
        { question_id: ids.join(",") }
      );
      this.showSelectPointModal = false;
      this.selectList = [];
      await this.$Message.info("转移成功");
      this.search();
    }
  }
};
</script>
<style lang="scss" scoped>
/deep/ .ivu-tooltip {
  .ivu-tooltip-rel {
    display: block;
  }
}
/deep/ .ivu-table-wrapper {
  overflow: unset;
  .ivu-table {
    overflow: unset;
  }
}
.stem {
  margin-bottom: 15px;
}
.option {
  border: 1px solid #d7d7d7;
  border-radius: 5px;
  padding: 5px;
  margin-bottom: 15px;
  .header {
    margin-bottom: 5px;
    .line {
      margin: 0 10px;
    }
  }
}
/deep/ .ivu-table-row td:nth-child(2) .ivu-table-cell {
  height: 48px;
  line-height: 48px;
}

/deep/ .ivu-tooltip {
  .ivu-tooltip-rel {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .ivu-tooltip-inner {
    max-width: 500px;
    white-space: unset;
  }
}
.line-topic {
  display: flex;
  > div:first-child {
    margin-right: 10px;
  }
  .stem {
    display: flex;
    align-items: flex-start;
  }
  .answer {
    display: flex;
    align-items: center;
    > span {
      margin-right: 10px;
    }
  }
}
.flex-tip {
  display: flex;
}
.rich-text-small {
  white-space: normal;
  line-height: 1.5;
  padding: 10px 0;
}
</style>
